/**
 * Shared constants and value mappings for location lists
 */

/**
 * Stock level value mappings for badges
 */
export const STOCK_LEVEL_VALUE_MAPPING = [
	{ value: 'Empty', label: 'Empty', color: { bg: '#fee2e2', text: '#991b1b' } },
	{ value: 'Low', label: 'Low', color: { bg: '#fef3c7', text: '#92400e' } },
	{
		value: 'Medium',
		label: 'Medium',
		color: { bg: '#dbeafe', text: '#1e40af' },
	},
	{ value: 'Full', label: 'Full', color: { bg: '#dcfce7', text: '#166534' } },
] as const;

/**
 * Required fields for basic location lists
 */
export const BASE_REQUIRED_FIELDS = [
	'location._id',
	'location.code',
	'location.description',
	'location.type',
	'location.locationCode',
	'location.capacity',
	'location.units',
	'location.status',
	'location.warehouseId',
];

/**
 * Required fields for merchandiser location lists
 */
export const MERCHANDISER_REQUIRED_FIELDS = [
	'location._id',
	'location.code',
	'location.description',
	'location.type',
	'location.status',
	'location.capacity',
];
